import React, { Component } from "react";
import { withLocalize } from "react-localize-redux";
import { withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";
import { reduxForm, Field, initialize, getFormValues } from "redux-form";
import { connect } from "react-redux";
import {
  DetailContainer,
  Description,
  FormContainer,
  ImageContainer,
  PremiumRefContainer,
  PremiumRefTitle,
  PremiumRefCards,
  PremiumRefCard,
  PremiumRefCardImage,
  PremiumRefCardTitle,
} from "./PageDetailStyles";
import ProgressBar from "../../components/progressBar/ProgressBar";
import DecorationNavigation from "../../components/decorationNavigation/DecorationNavigation";
import DecorationMenu from "../../components/decorationMenu/DecorationMenu";
import SaveButton from "../../components/buttons/SaveButton";
import DecorationObservation from "../../components/decorationObservation/DecorationObservation";
import {
  findPageByTag,
  findPageByID,
  findQuestionByID,
  findNumberQuestionsChapter,
  removeFireworksOptionsFromQuestion,
  hideOptionsIfNotSelected,
  findQuestionInAllSections,
  getAllSelectedOptionIds,
  evaluateOptionDependency,
  buildQuestionOptionsMap
} from "../../infra/services/utils/PageInfo";
import {
  editObservations,
  editSection,
  processClosed,
} from "../../infra/services/utils/BlockAnswers";
import {
  checkIfTimelineIsNextQuestion,
  findNextQuestion,
  findPrevQuestion,
  isLastQuestion,
} from "../../infra/services/utils/PageNavigation";
import ManageQuestionType from "../../components/manageQuestionType/ManageQuestionType";
import ImageComponent from "../../components/images/ImageComponent";
import { AnswerQuestion, AnswerQuestionTableTheme, CanLoadCoximLacoChairs, CommunicateGraphics } from "../../infra/requests/MyWeddingRequests";
import { updateQuestionAction, updateAnswersAction, updateAboutUsAction } from "../../redux/Wedding/wedding.actions";
import { TransformToFormData } from "../../infra/services/formdata/TransformToFormData";
import { SpinLoading } from "../../styles/BasicStyles";
import LeavePageBlocker from "../../components/pageBlocker/LeavePageBlocker";
import ImageModal from "../../../src/components/imageModal/ImageModal";
import Alerts from "../../components/alert/Alert";
import { correctResponseValues } from "../../components/optionCard/OptionUtils";
import { CheckUpdateCoupleTable } from "../../infra/requests/GuestsRequests";
import { GetFlowersForCoupleToSelect } from "../../infra/requests/OrderFlowersRequests";
import { Icon, Modal, Popconfirm } from "antd";
import BaseButton from "../../components/buttons/BaseButton";
import { inGuestMapTest } from "../../infra/services/utils/Helpers";
import { checkCoupleTableAnswer, removeNotExistingOptions } from "../../infra/services/utils/Options";

const { confirm } = Modal;

const FormValidations = (values) => {
  //console.log('FORM', values);
  return {};
};

class PageDetail extends Component {
  state = {
    question: undefined,
    chapter: undefined,
    nextQuestion: undefined,
    prevQuestion: undefined,
    num_questions: undefined,
    num_answers: undefined,
    canEditSection: undefined,
    isProcessClosed: undefined,
    isBlockedForCouple: false,
    isChapterBlocked: false,
    showImageModal: false,
    selectedImage: undefined,
    ready: false,
    loading: false,
    confirmSubmitting: false,
    flowersList: [],
    communicatingGraphics: false
  };

  componentDidMount() {
    window.scroll({ top: 0, left: 0, behavior: "smooth" });
    document.body.style.overflowY = "auto";

    this.updateQuestion();
    this.getFlowers();
  }

  componentDidUpdate(prevProps) {
    if (this.props.id !== prevProps?.id) {
      window.scroll({ top: 0, left: 0, behavior: "smooth" });
      document.body.style.overflowY = "auto";

      this.updateQuestion();
    }
  }

  getFlowers = async () => {
    const { wedding } = this.props;
    const result = await GetFlowersForCoupleToSelect(wedding?._id, this.props.tag);
    if (result?.success) {
      this.setState({ flowersList: result?.data });
    }
  }

  updateQuestion = async () => {
    const { decorationInfo, weddingDate, blockDate, history, dispatch, wedding } = this.props;
    const { chapters } = findPageByTag(decorationInfo, this.props.tag);
    const question = findQuestionByID(chapters, this.props.id);

    if (!question) {
      history.push("/404");
      return false;
    }

    // IF QUESTION IS COXIM OR LACO
    let loadCoximLaco = true;
    if (
      question?._id === '5e18a7f686fdaa220deeddc5' ||
      question?._id === '5e18abf786fdaa0cc7eeddcd'
    ) {
      const result = await CanLoadCoximLacoChairs(wedding?._id);
      if (result?.success) {
        loadCoximLaco = result?.data;
      }
    }
    this.setState({ loadCoximLaco });

    const chapter = findPageByID(chapters, question.chapter);
    let nextQuestion = findNextQuestion(
      decorationInfo,
      chapters,
      chapter,
      question._id
    );
    const prevQuestion = findPrevQuestion(
      decorationInfo,
      chapters,
      chapter,
      question._id
    );
    const { num_questions, num_answers } = findNumberQuestionsChapter(chapter);
    const canEditSection = editSection(weddingDate, this.props.tag);
    // const isProcessClosed = processClosed(weddingDate);
    const isProcessClosed = processClosed(blockDate);
    const isBlockedForCouple = question?.answer?.blockedForCouple === true;
    //The whole chapter can be blocked by the venue for this wedding
    const isChapterBlocked = chapter?.blockedForCouple === true;

    //Check if it's the last question of the last section
    const lastQuestion = isLastQuestion(decorationInfo, question._id);
    if (lastQuestion) {
      nextQuestion = { tag: "UPGRADE", url: "/upgrade" };
    }

    dispatch(initialize("section_form", {}));

    if (question?.answer) {
      dispatch(
        initialize("section_form", {
          ...question?.answer,
          question_obs: question?.answer?.observations !== "",
        })
      );
    }

    this.setState({
      question,
      chapter,
      nextQuestion,
      prevQuestion,
      num_questions,
      num_answers,
      canEditSection,
      isProcessClosed,
      isBlockedForCouple,
      isChapterBlocked,
      ready: true
    });

    this.isNextQuestionTimeline(decorationInfo, question);
    this.isPrevQuestionTimeline(chapter, question);
  };

  confirmSubmitModal = async (values) => {
    const { translate } = this.props;
    const { wedding } = this.props;
    const { question } = this.state;
    this.setState({ confirmSubmitting: true });

    // Check if required time fields are filled
    if (values?.response?.length > 0 && question?.options?.length > 0) {
      const missingTime = values.response.some(answer => {
        const opt = question.options.find(o => o._id === answer.id);
        return opt?.requiresTime && !answer.time;
      });
      if (missingTime) {
        Alerts.new({
          type: 'error',
          title: translate('ERROR'),
          text: 'Por favor preencha o horário para todas as opções selecionadas que o requerem.'
        });
        this.setState({ confirmSubmitting: false });
        return;
      }
    }

    // Check if couple table question
    if (inGuestMapTest() && question?._id == '5e18723686fdaa6d7aeedd91') {
      const data = checkCoupleTableAnswer(values, question, wedding.wedding_place);
      const resultCheck = await CheckUpdateCoupleTable(data);

      if (resultCheck?.success) {
        if (resultCheck?.data?.showWarning) {
          const ovalLWarning = resultCheck?.data?.showOvalLWarning
            ? resultCheck?.data?.ovalLWarning == 'TO_REMOVE_TABLES_BY_OVALL'
              ? translate('TO_REMOVE_TABLES_BY_OVALL')?.replace('#tables#', resultCheck?.data?.tablesToRemove)
              : resultCheck?.data?.ovalLWarning == 'TO_RESTORE_TABLES_BY_OVALL'
                ? translate('TO_RESTORE_TABLES_BY_OVALL')?.replace('#tables#', resultCheck?.data?.tablesToRemove)
                : null
            : null;

          if (resultCheck?.data?.showOvalLWarning && resultCheck?.data?.tablesToRemoveFilled) {
            this.setState({ showModal: false }, () => {
              Modal.warning({
                title: translate('ATTENTION'),
                content: translate('COUPLE_REMOVE_WITH_OVALL_BLOCKED'),
              });
            })
            return;
          }

          confirm({
            title: translate('UPDATE_COUPLE_TABLE_QUESTION'),
            content: (<div>
              <p>{translate('UPDATE_COUPLE_TABLE_CONTENT')}</p>
              {resultCheck?.data?.showOvalLWarning && ovalLWarning && <p><b>{ovalLWarning}</b></p>}
            </div>
            ),
            okText: translate('CHANGE_TABLE'),
            cancelText: translate('CANCEL'),
            onOk: () => {
              this.onSubmit(values);
            },
            onCancel: () => {
              this.setState({ confirmSubmitting: false });
              return;
            },
          });
        } else this.onSubmit(values);
      } else {
        Alerts.new({
          type: 'error',
          title: translate('ERROR'),
          text: translate(resultCheck.message)
        })
        this.setState({ confirmSubmitting: false });
        return;
      }
    }
    // Check if question hasOnlyOneOptions and has options selected with onlyOneAvailable tag
    // else if (question?.hasOnlyOneOptions && answer?.response?.length > 0) {
    //   const respIds = answer?.response?.map(m => m?.id);
    //   const onlyOneOptionsSelected = respIds?.length > 0 && question?.options?.filter(f => f?.onlyOneAvailable)?.length > 0
    //     ? question?.options?.filter(f => f?.onlyOneAvailable).filter(f => respIds.includes(f?._id))
    //     : [];
    //   const hasOnlyOneOptionSelected = onlyOneOptionsSelected?.length > 0;

    //   if (hasOnlyOneOptionSelected) {
    //     confirm({
    //       title: translate('LIMITED_AVAILABILITY_TITLE'),
    //       content: (<div>
    //         <p>{translate('LIMITED_AVAILABILITY_INFO')}</p>
    //         <p><b>{translate('LIMITED_AVAILABILITY_QUESTION')}</b></p>
    //       </div>
    //       ),
    //       okText: translate('CONTINUE'),
    //       cancelText: translate('CANCEL'),
    //       onOk: () => this.onSubmit(values),
    //       onCancel: () => {
    //         this.setState({ confirmSubmitting: false });
    //         return;
    //       },
    //     });
    //   } else this.onSubmit(values);
    // } 
    else {
      this.onSubmit(values);
    }

  }

  onSubmit = async (values) => {
    try {
      this.setState({ loading: true });

      const { history, dispatch, updateQuestionAction, updateAnswersAction, translate, wedding, food } = this.props;
      const { nextQuestion, question } = this.state;

      if (question?.options && question?.options?.length > 0) {
        values = removeNotExistingOptions(values, question, wedding?.wedding_place, food);
      }
      values = correctResponseValues(values);
      const payload = TransformToFormData({
        ...values,
        question: question._id,
      });

      let result;
      if (question?.isTableTheme) {
        result = await AnswerQuestionTableTheme(payload);
      } else {
        result = await AnswerQuestion(payload);
      }

      if (result?.success) {
        const payload = result.data || {};
        console.warn('[onSubmit] response envelope:', payload);
        const savedAnswer = payload.answer || payload;
        const affectedAnswers = Array.isArray(payload.affectedAnswers) ? payload.affectedAnswers : [];
        console.warn('[onSubmit] affectedAnswers.length=', affectedAnswers.length);

        dispatch(updateQuestionAction(this.props.tag, savedAnswer));
        if (affectedAnswers.length > 0) {
          dispatch(updateAnswersAction(affectedAnswers));
        }

        history.push(nextQuestion?.url);
      } else {
        if (result?.message === "WEDDING_OPTION_NOT_AVAILABLE") {
          Alerts.new({
            type: 'warning',
            title: translate('WEDDING_OPTION_NOT_AVAILABLE'),
            text: translate('WEDDING_OPTION_NOT_AVAILABLE_EMAIL')
          });
          history.push(nextQuestion?.url);
        } else if (result?.message == 'UPGRADE_BLOCKED_BOTH_MAIN_DISHES') {
          Alerts.new({
            type: 'error',
            title: translate('ERROR'),
            text: translate('UPGRADE_BLOCKED_BOTH_MAIN_DISHES')
          });
        } else if (result?.message == 'CHAPTER_BLOCKED_BY_VENUE') {
          //The chapter was blocked while the couple had this page open
          Alerts.new({
            type: 'error',
            title: translate('BLOCKED_ANSWER_TITLE'),
            text: translate('CHAPTER_BLOCKED_BY_VENUE')
          });
          this.setState({ isChapterBlocked: true });
        }
      }

      this.setState({
        loading: false,
        confirmSubmitting: false
      });
    } catch (e) {
      console.log(e);
      this.setState({
        loading: false,
        confirmSubmitting: false
      });
    }
  };

  isNextQuestionTimeline = (sections, question) => {
    if (checkIfTimelineIsNextQuestion(sections, question)) {
      this.setState({
        nextQuestion: {
          tag: 'OUR_DAY',
          url: '/our-day-timeline',
        }
      });
    }
  }

  isPrevQuestionTimeline = (chapter, question) => {
    if (String(chapter?.section) === '5e061eac47f1554b3dd6d416' && chapter?.order === 0) {
      if (question?.order === 0) {
        this.setState({
          prevQuestion: {
            tag: 'OUR_DAY',
            url: '/our-day-timeline',
          }
        });
      } else if (question?.order === 1) {
        this.setState({
          prevQuestion: {
            tag: 'OUR_DAY',
            url: '/our-day-timeline',
          }
        });
      }
    }
  }

  saveCurrentResponse = async () => {
    try {
      const { dispatch, updateQuestionAction, updateAnswersAction, wedding, food } = this.props;
      const { question } = this.state;

      let values = this.props.formValues;

      if (question?.options && question?.options?.length > 0) {
        values = removeNotExistingOptions(values, question, wedding?.wedding_place, food);
      }
      values = correctResponseValues(values);
      const payload = TransformToFormData({
        ...values,
        question: question._id,
      });

      let result;
      if (question?.isTableTheme) {
        result = await AnswerQuestionTableTheme(payload);
      } else {
        result = await AnswerQuestion(payload);
      }

      if (result?.success) {
        const payload = result.data || {};
        const savedAnswer = payload.answer || payload;
        const affectedAnswers = Array.isArray(payload.affectedAnswers) ? payload.affectedAnswers : [];

        dispatch(updateQuestionAction(this.props.tag, savedAnswer));
        if (affectedAnswers.length > 0) {
          dispatch(updateAnswersAction(affectedAnswers));
        }
        return true;
      }
      return false;
    } catch (e) {
      console.log(e);
      return false;
    }
  }

  handleCommunicateGraphics = async () => {
    const { translate, dispatch, dirty } = this.props;
    this.setState({ communicatingGraphics: true });

    if (dirty) {
      const saved = await this.saveCurrentResponse();
      if (!saved) {
        this.setState({ communicatingGraphics: false });
        return;
      }
    }

    const result = await CommunicateGraphics();

    if (result?.success) {
      dispatch(updateAboutUsAction(result.data));
      Alerts.new({
        type: 'success',
        title: translate('SUCCESS'),
        text: result.data?.graphicsCommunicated
          ? translate('GRAPHICS_COMMUNICATED_SUCCESS')
          : translate('GRAPHICS_UNCOMMUNICATED_SUCCESS')
      });
    } else {
      Alerts.new({
        type: 'error',
        title: translate('ERROR'),
        text: result?.message === 'GRAPHICS_BLOCKED'
          ? translate('GRAPHICS_BLOCKED_ERROR')
          : translate('GENERIC_ERROR')
      });
    }

    this.setState({ communicatingGraphics: false });
  }

  render() {
    const {
      handleSubmit,
      translate,
      activeLanguage,
      history,
      dirty,
      submitting,
      decorationInfo,
    } = this.props;
    const {
      question,
      chapter,
      nextQuestion,
      prevQuestion,
      num_questions,
      num_answers,
      canEditSection,
      isProcessClosed,
      isBlockedForCouple,
      isChapterBlocked,
      showImageModal,
      selectedImage,
      ready,
      loading,
      loadCoximLaco,
      flowersList
    } = this.state;
    const { confirmSubmitting } = this.state;

    const { communicatingGraphics } = this.state;
    const { wedding } = this.props;

    if (!ready) return <SpinLoading />;

    // validate if the question have firework options and if its true it removes that options if necessary
    // question.options = removeFireworksOptionsFromQuestion(question)?.options;
    question.options = hideOptionsIfNotSelected(question);

    const allSelectedOptionIds = getAllSelectedOptionIds(decorationInfo);
    const questionOptionsMap = buildQuestionOptionsMap(decorationInfo);
    question.options = question.options.filter(opt => evaluateOptionDependency(opt, allSelectedOptionIds, questionOptionsMap).show);

    const PREMIUM_QUESTION_ID = '5e1c3d367ad7e1b27069f9b4';
    const FAQUEIRO_QUESTION_ID = '69774bc5b380e58224fc333f';
    const COPOS_QUESTION_ID = '5e18bb637ad7e1669969f961';

    const showPremiumRef = question._id === FAQUEIRO_QUESTION_ID || question._id === COPOS_QUESTION_ID;
    let premiumSelectedOptions = [];
    let premiumQuestion = undefined;
    if (showPremiumRef) {
      premiumQuestion = findQuestionInAllSections(decorationInfo, PREMIUM_QUESTION_ID);
      if (premiumQuestion?.answer?.response?.length > 0 && premiumQuestion?.options?.length > 0) {
        const selectedIds = premiumQuestion.answer.response.map(r => r.id);
        premiumSelectedOptions = premiumQuestion.options.filter(opt => selectedIds.includes(opt._id));
      }
    }

    //A blocked question, or a chapter blocked by the venue, prevents any answer
    const answersBlocked = isBlockedForCouple || isChapterBlocked;

    const GRAPHICS_QUESTION = '6960d7da060acc26e86129ba';
    const isGraphicsQuestion = question._id === GRAPHICS_QUESTION;
    const graphicsCommunicated = wedding?.graphicsCommunicated || false;
    const graphicsBlocked = wedding?.graphicsBlocked || false;
    const graphicsLocked = isGraphicsQuestion && (graphicsCommunicated || graphicsBlocked);

    return (
      <React.Fragment>
        <LeavePageBlocker
          when={dirty && !submitting && !confirmSubmitting}
          message={translate("UNSAVED_OPTION_CHANGES")}
        />
        <ProgressBar
          type="section"
          num_questions={num_questions}
          num_answers={num_answers}
        />
        <DecorationNavigation
          returnUrl={this.props.url}
          mainCategory={chapter.name[activeLanguage?.code]}
          currentQuestion={question.title[activeLanguage?.code]}
          currentQuestionUrl={`${this.props.url}/${question._id}`}
          nextQuestion={
            nextQuestion?.tag
              ? translate(nextQuestion?.tag)
              : nextQuestion?.name[activeLanguage?.code]
          }
          nextQuestionUrl={nextQuestion?.url}
          prevQuestion={
            prevQuestion?.tag
              ? translate(prevQuestion?.tag)
              : prevQuestion?.name[activeLanguage?.code]
          }
          prevQuestionUrl={prevQuestion?.url}
          chapter={chapter}
          wedding={this.props.wedding}
        />
        <DecorationMenu
          baseUrl={this.props.url}
          questions={chapter.questions}
        />
        <DetailContainer>
          {question.description && (
            <Description
              dangerouslySetInnerHTML={{
                __html:
                  question.description &&
                  question.description[activeLanguage?.code],
              }}
            />
          )}
          {question.images.length > 0 && (
            <ImageContainer total={question.images.length}>
              {question.images.map((elem, index) => (
                <ImageComponent
                  key={index}
                  url={elem.url}
                  color={elem.color}
                  bgContain={true}
                  zoom={true}
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    this.setState({ showImageModal: true, selectedImage: elem });
                  }}
                />
              ))}
            </ImageContainer>
          )}
          {showImageModal && (
            <ImageModal
              title={question.title[activeLanguage?.code]}
              image={selectedImage.url}
              color={selectedImage?.color}
              handleCancel={() => this.setState({ showImageModal: false, selectedImage: undefined })}
            />
          )}
          {showPremiumRef && premiumSelectedOptions.length > 0 && (
            <PremiumRefContainer>
              <PremiumRefTitle>{premiumQuestion?.title[activeLanguage?.code]}</PremiumRefTitle>
              <PremiumRefCards>
                {premiumSelectedOptions.map((opt, i) => (
                  <PremiumRefCard key={i}>
                    <PremiumRefCardImage>
                      <ImageComponent
                        url={opt.image?.url}
                        color={opt.image?.color}
                        ratio={0.6}
                      />
                    </PremiumRefCardImage>
                    <PremiumRefCardTitle>{opt.title[activeLanguage?.code]}</PremiumRefCardTitle>
                  </PremiumRefCard>
                ))}
              </PremiumRefCards>
            </PremiumRefContainer>
          )}
          {isGraphicsQuestion && !isProcessClosed && (
            <div style={{ marginBottom: '20px', display: 'flex', justifyContent: 'flex-end', width: '100%' }}>
              {graphicsBlocked ? (
                <div style={{ display: 'flex', alignItems: 'center', color: '#f5222d', fontSize: 14, fontWeight: 500 }}>
                  <Icon type="exclamation-circle" style={{ marginRight: 8, fontSize: 18 }} />
                  {translate('GRAPHICS_BLOCKED_BY_VENUE')}
                </div>
              ) : (
                <Popconfirm
                  title={graphicsCommunicated
                    ? translate('GRAPHICS_UNCOMMUNICATE_CONFIRM')
                    : translate('GRAPHICS_COMMUNICATE_CONFIRM')
                  }
                  onConfirm={this.handleCommunicateGraphics}
                  okText={translate('CONFIRM')}
                  cancelText={translate('CANCEL')}
                  okType={'primary'}
                >
                  <span style={{ marginRight: '15px' }}>
                    <BaseButton
                      type={graphicsCommunicated ? "default": "primary"}
                      loading={communicatingGraphics}
                      text={graphicsCommunicated
                        ? translate('GRAPHICS_UNCOMMUNICATE')
                        : translate('GRAPHICS_COMMUNICATE')
                      }
                    />
                  </span>
                </Popconfirm>
              )}
            </div>
          )}
          {isChapterBlocked && (
            <div style={{ marginBottom: '20px', display: 'flex', alignItems: 'center', color: '#f5222d', fontSize: 14, fontWeight: 500 }}>
              <Icon type="lock" style={{ marginRight: 8, fontSize: 18 }} />
              {translate('CHAPTER_BLOCKED_BY_VENUE')}
            </div>
          )}
          {loadCoximLaco && <FormContainer onSubmit={handleSubmit(this.confirmSubmitModal)}>
            <Field
              name="response"
              component={ManageQuestionType}
              question={question}
              canEditSection={canEditSection}
              isProcessClosed={isProcessClosed || answersBlocked}
              isBlockedForCouple={answersBlocked}
              blockedMessageTag={isChapterBlocked ? 'CHAPTER_BLOCKED_BY_VENUE' : 'ROOM_PLAN_BLOCKED_FOR_COUPLE'}
              graphicsLocked={graphicsLocked}
              flowersList={flowersList}
              allSelectedOptionIds={allSelectedOptionIds}
            questionOptionsMap={questionOptionsMap}
            />
            {question.observations && (
              <DecorationObservation
                inputLabel={translate("OBSERVATIONS_WD")}
                canEditSection={canEditSection ? editObservations(question) : canEditSection}
                isProcessClosed={isProcessClosed || answersBlocked}
              />
            )}
            {canEditSection && !isProcessClosed && !answersBlocked && (
              <SaveButton
                htmlType="submit"
                text={translate("SAVE_CONTINUE")}
                textMobile={translate("SAVE")}
                withBackground={true}
                loading={loading}
              />
            )}
          </FormContainer>}
          {(!canEditSection || isProcessClosed || answersBlocked) && (
            <SaveButton
              htmlType="button"
              text={translate("CONTINUE")}
              textMobile={translate("CONTINUE")}
              withBackground={true}
              onClick={() => history.push(nextQuestion?.url)}
            />
          )}
        </DetailContainer>
      </React.Fragment>
    );
  }
}

const PageDetailForm = reduxForm({
  form: "section_form",
  validate: FormValidations,
})(PageDetail);

const mapStateToProps = (state) => ({
  decorationInfo: state.wedding.structure,
  colors: state.info.colours,
  wedding: state.wedding.wedding,
  weddingDate: state.wedding.wedding.date,
  blockDate: state.wedding.wedding.blockDate,
  food: state.info.food,
  formValues: getFormValues('section_form')(state)
});

const mapActionToProps = (dispatch) =>
  bindActionCreators({ updateQuestionAction, updateAnswersAction, updateAboutUsAction, dispatch }, dispatch);

export default connect(
  mapStateToProps,
  mapActionToProps
)(withLocalize(withRouter(PageDetailForm)));
